import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'

const useStyles = makeStyles(() => ({
    title: {
        position: 'relative',
        textAlign: 'center',
        fontFamily: tokens.fontHeading,
        fontSize: 48,
        fontWeight: 700,
        color: tokens.colorBlack,
        margin: '0 0 42px',
        padding: '0 0 18px',
        letterSpacing: '.5px',
        '&::after': {
            content: '""',
            position: 'absolute',
            left: '50%',
            bottom: 0,
            transform: 'translateX(-50%)',
            width: 56,
            height: 4,
            borderRadius: 2,
            background: tokens.colorAccentRed,
        },
    },
    left: {
        textAlign: 'left',
        marginBottom: 20,
        '&::after': { left: 0, transform: 'none' },
    },
    accent: { color: tokens.colorAccentRed },
    white: {
        color: '#fff',
        '&::after': { background: '#fff' },
    },
}))

export function SectionTitle({ variant, className = '', children }) {
    const classes = useStyles()
    const variantClass =
        variant === 'left' ? classes.left :
        variant === 'accent' ? classes.accent :
        variant === 'white' ? classes.white : ''
    return (
        <h2 className={`${classes.title} ${variantClass} ${className}`}>
            {children}
        </h2>
    )
}
